import { createApp } from 'vue'
import http from './plugins/http';
import Login from '../components/Account/Login.vue';

document.addEventListener('DOMContentLoaded', () => {
    const login = document.querySelector('#acc-app')
    if( login ) {
        const login_app = createApp( Login )
        login_app.use(http)
        login_app.mount('#acc-app')
    }
})